module.exports = __webpack_public_path__ + "img/whitelogo.3c817543.png";